import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Callback from './views/Callback.vue';
import NotLogged from './views/NotLogged.vue';
import NotFound from './views/NotFound.vue';
import Resumo from './views/Resumo.vue';
import Produtos from './views/Produtos.vue';
import Personalizar from './views/Personalizar.vue';
import Detalhamento from './views/Detalhamento.vue';
import Catalogo from './views/Catalogo.vue';
import DashboardGestor from './views/DashboardGestor.vue';
import Login from './components/Login.vue';
import Signup from './components/Signup.vue';
import RecuperarSenha from './components/RecuperarSenha.vue';
import Tarefas from './views/Tarefas.vue';
import GestaoContatos from './views/GestaoContatos.vue';
import CadastrarLead from './views/CadastrarLead.vue';
import SearchVoucher from './views/SearchVoucher.vue';
import Multitenant from './views/Multitenant.vue';
import InviteCadastro from './views/InviteCadastro.vue';
import Cadastro from './views/Cadastro.vue';
import Dashboard from './views/Dashboard.vue';
import TermosdeUso from './views/TermosdeUso.vue';
import Sellers from './views/Sellers.vue';
import Pedidos from './views/Pedidos.vue';
import PedidoDetalhes from './views/PedidoDetalhes.vue';
import editSeller from './views/editSeller.vue';
import { APIService } from './resources/campanha.js';

const api = new APIService();

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/index.html',
      component: Home,
      alias: '/',
    },
    {
      path: '/campaigns',
      name: 'campaigns',
      component: Dashboard,
    },
    {
      path: '/termosdeuso',
      name: 'termosdeuso',
      component: TermosdeUso,
    },
    {
      path: '/login/vendedor',
      name: 'multitenant',
      component: Multitenant,
    },
    {
      path: '/invite/:id',
      name: 'inviteCadastro',
      component: InviteCadastro,
    },
    {
      path: '/cadastro/editar',
      name: 'cadastro',
      component: Cadastro,
      props: { isEditing: true },
    },
    {
      path: '/cadastro',
      name: 'cadastro',
      component: Cadastro,
    },
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/recuperarsenha',
      name: 'recuperarsenha',
      component: RecuperarSenha,
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/gestaocontatos',
      name: 'gestaocontatos',
      component: GestaoContatos,
    },
    {
      path: '/cadastrarlead',
      name: 'cadastrarlead',
      component: CadastrarLead,
    },
    {
      path: '/resumo',
      name: 'resumo',
      component: Resumo,
    },
    {
      path: '/produtos',
      name: 'produtos',
      component: Produtos,
    },
    {
      path: '/produtos/:id',
      name: 'detalhamento de produtos',
      component: Detalhamento,
    },
    {
      path: '/personalizar/',
      name: 'personalizar',
      component: Personalizar,
    },
    {
      path: '/catalogo/',
      name: 'catalogo',
      component: Catalogo,
    },
    {
      path: '/tarefas',
      name: 'tarefas',
      component: Tarefas,
    },
    {
      path: '/pedidos',
      name: 'pedidos',
      component: Pedidos,
    },
    {
      path: '/pedido/:id',
      name: 'pedido',
      component: PedidoDetalhes,
    },
    {
      path: '/tarefas',
      name: 'tarefas',
      component: Tarefas,
    },
    {
      path: '/contato/:id',
      name: 'contato',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/DetalhesContato.vue'),
    },
    {
      path: '/contatos',
      name: 'contatos',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Contatos.vue'),
    },
    {
      path: '/callback',
      name: 'callback',
      component: Callback,
    },
    {
      path: '/403',
      name: '403',
      component: NotLogged,
    },
    {
      path: '/404',
      name: '404',
      component: NotFound,
    },

    {
      path: '/dashboard/gestor',
      name: 'dashboard_gestor',
      component: DashboardGestor,
    },
    {
      path: '/sellers',
      name: 'sellers',
      component: Sellers,
    },
    {
      path: '/sellers/:id',
      name: 'editSeller',
      component: editSeller,
    },

    {
      path: '/voucher',
      name: 'voucher',
      component: SearchVoucher,
    },

  ],
});

router.beforeEach(async (to, from, next) => {
  console.log(to, from);
  if (to.path.includes('autoLogin')) {
    router.app.$auth.newLogin(to.query.user, to.query.pw, (err) => {
      if (err && err.code == 'invalid_grant') {
        console.log('Invalid grant', err);
        next('login');
      } else if (err) {
        console.log('Error', err);
        next('login');
      }
    });
    // router.app.$auth.login();
    next('');
  } else if (to.name == 'multitenant') {
    if (router.app.$store.state.hasMultitenant) next();
    else next('');
  } else if (router.app.$auth.isAuthenticated() && to.name == 'login') {
    next('login/vendedor');
  } else if (to.name == 'callback' || to.name == '403' || to.name == 'login' || to.name == 'signup' || to.name == 'recuperarsenha' || to.name == 'cadastro' || to.name == 'inviteCadastro') { // check if "to"-route is "callback" and allow access
    next();
  } else if (router.app.$auth.isAuthenticated()) { // if authenticated allow access
    if (to.name == 'dashboard_gestor' || to.name == 'gestaocontatos') {
      if (router.app.$store.getters.isManager || router.app.$store.getters.isDirector) {
        next();
      } else {
        next('');
      }
    } else {
      next();
    }
  } else { // trigger auth0 login
    next('login');
    // router.app.$auth.login();
  }
});

export default router;
